import {downloadArrayBuffer}     from "@Common/utils/browser/download-array-buffer";
import {guessImgBinaryExtension} from "@Common/utils/browser/guess-img-binary-extension";

import {downloadAsZip} from "./download-as-zip";

export const downloadProofs = async (urls, itemId, sides, onDownloadProgress=null, build3ProdDownload=false) => {
    if (urls && Array.isArray(urls) && sides) {
        if (urls.length > 1) {

            // fake the download progress - need to replace downloadAsZip with separate process to capture actual download
            onDownloadProgress && onDownloadProgress(1);

            await downloadAsZip(
                urls.map( (url, index) => ({
                    url,
                    getFilePath: (binary) => {
                        let extension = guessImgBinaryExtension(binary) || url.split('.').pop().split(/#|\?/)[0];

                        // If extension is a number, get it from the path parameter in the URL
                        if (!isNaN(extension)) {
                            // url is invalid so adding hostname to url
                            url = "https://" + window.location.hostname + url;

                            const urlObj = new URL(url);
                            const pathParam = urlObj.searchParams.get("path");
                            if (pathParam) {

                                extension =  pathParam.split('.').pop();
                            }
                        }

                        return `${itemId}_${sides[index]}.${extension}`;
                    },
                })),
                {fileName: `${itemId}_Proofs.zip`},
            );

            onDownloadProgress && onDownloadProgress(101); // progress to 101 sets as faked meter with slower transition

        } else if (urls && urls[0]) {
            // fake the download progress - convert to XHR after implementing progress metering where this is run:
            // xpressdocs_next/ui/xpresso/src/routes/approval-requests/common/expansion/card/card.tsx
            onDownloadProgress && onDownloadProgress(1);

            await fetch(urls[0], {
                method: "GET",
                headers: {}
            })
                .then(response => {
                    response.arrayBuffer().then(function (buffer) {
                        build3ProdDownload ? downloadArrayBuffer(buffer, {fileName: `${itemId}.pdf`}) : downloadArrayBuffer(buffer, {fileName: `${itemId}.jpg`});
                    });
                })
                .catch(err => {
                    console.log(err);
                });

            onDownloadProgress && onDownloadProgress(101); // progress to 101 sets as faked meter with slower transition

        }
    } else if (urls) {
        // fake download progress if multiple files to download
        if (urls.length > 1) {
            onDownloadProgress && onDownloadProgress(101); // progress to 101 sets as faked meter with slower transition
        }

        let xhrPromises = urls.map(url => {
            return new Promise(resolve => {
                let xhr = new XMLHttpRequest();
                xhr.responseType = "blob";

                // add real download progress if only one file
                if (urls.length === 1 && onDownloadProgress) {
                    xhr.addEventListener("progress", event => {
                        if (event.lengthComputable) {
                            onDownloadProgress(Math.round((event.loaded / event.total) * 100));
                        }
                    });
                }

                xhr.addEventListener("loadend", () => {
                    downloadArrayBuffer(xhr.response, { fileName: `${itemId}.pdf` });
                    resolve(true);
                });

                xhr.open("GET", url, true);
                xhr.send();
            });
        });

        await Promise.all(xhrPromises);

    }
};
